// src/services/adminSegments.api.js
import { adminApiRequest } from "./adminApi";

export const getAdminCustomerSegments = () => {
  return adminApiRequest("/admin/customers/segments/list");
};

export const sendSegmentEmailCampaign = (data) => {
  return adminApiRequest("/admin/customers/segments/send-email", {
    method: "POST",
    body: JSON.stringify(data),
  });
};